import React, { useState, useEffect } from "react";
import {connect} from 'react-redux';
import Spinner from 'react-bootstrap/Spinner';
import * as commonActions from '../../store/common/actions';
import { showLoading, hideLoading } from 'react-redux-loading-bar';
import SpotifyPlaylist from "./spotifyPlaylist";
import * as isplayingActions from '../../store/isplaying/actions';

const  SpotifyPlaylists = ({ getSpotifyPlaylists, spotifyPlaylistObject, displayLoading, hideLoading, setIsPlaying }) => {

    useEffect(() => { 
        loadData();
    },[])

    const loadData = async () => {
        displayLoading();
        const data = {
            pageName: 'home'
        };
        
        // Get Latest Songs
        await getSpotifyPlaylists(data);
        hideLoading();
    }

    const spotifyClicked = () => {
        setIsPlaying(false)
    }
    

    if(spotifyPlaylistObject && spotifyPlaylistObject.spotifyplaylists){
        return (
            <div className="play-list-sec ">
                <div className="top-heading">
                    <h2>CK Spotify Playlists</h2>
                </div>
                <div className="inner-block spotify-grid-container"
                    
                >
                    {
                        spotifyPlaylistObject.spotifyplaylists.map((playlist, index)=>{
                            return <div key={`spotifyplaylist-${playlist.id}`} className="play-track" onClick={spotifyClicked}>
                                {/* <SpotifyPlaylist url={playlist.spotify_url } /> */}
                                <SpotifyPlaylist url={playlist.spotify_url } />
                            </div>
                        })
                    }
                </div>
            </div>
            
            
            
        );
    } else {
        return null;
    }
  
}


function mapStateToProps(state) {
    return {
        spotifyPlaylistObject: state.common.spotifyPlaylists
    };
 }
 
 function mapDispatchToProps(dispatch) {
    return {
        getSpotifyPlaylists: (post) => dispatch(commonActions.getSpotifyPlaylists(post)),
        displayLoading: (sectionBar) => dispatch(showLoading(sectionBar)),
        hideLoading: (sectionBar) => dispatch(hideLoading(sectionBar)),
        setIsPlaying: ( isPlaying ) => dispatch(isplayingActions.setIsPlaying(isPlaying) ),
    };
 }

export default connect(mapStateToProps, mapDispatchToProps)(SpotifyPlaylists);